import React from "react";
import styled from "styled-components";

import { Stars } from "../../genericComponents";

export default function BoardSection(props) {
  return (
    <SectionBoards>
      <Image alt='image' src={props.imageUrl} />
      <DescriptionSection>
        <Title>{props.title}</Title>
        <ReviewsSection>
          <StyledStars color='yellow' numberOfStars={props.rating} />
          <BoardsReview>{props.reviewsCount || 0} Reviews</BoardsReview>
        </ReviewsSection>

        <Description>{props.description}</Description>
        <ButtonsContainer>
          <Button onClick={() => props.onLockerButtonPress(props.onLocker)}>
            {props.onLocker ? "Remove from locker" : "Add to locker"}
          </Button>

          <a rel='noopener noreferrer' target='_blank' href={props.link}>
            <Button>
              <span className='icons-target' style={{ color: "yellow" }}>
                &nbsp;
            </span>{" "}
            Buy from
          </Button>
          </a>

          <Button onClick={() => props.handleCreateReview(props.id, props.title)}>
            Write a Review
          </Button>
        </ButtonsContainer>
      </DescriptionSection>
    </SectionBoards>
  )
}



const SectionBoards = styled.section`
  padding: 40px 16px;
  max-width: 1200px;
  display: flex;
  margin: auto;
`;

const Image = styled.img`
  object-fit: contain;
  height: 250px;
  width: 30%;
  margin-right: 40px;
  @media (max-width: 720px) {
    display: none;
  }
`;

const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Title = styled.h1`
  font-family: inherit;
  margin: 0 0 1.7rem;
  font-weight: 700;
  line-height: 1.1;
  color: inherit;
  color: ${(props) => props.theme.color.darkBlue};
`;

const ReviewsSection = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const StyledStars = styled(Stars)`
  display: inline-block;
  text-align: left;
`;

const BoardsReview = styled.div`
  margin-top: 13px;
  a {
    color: ${(props) => props.theme.color.darkBlue} !important;
  }
  line-height: 1.5em;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  margin-left: 30px;
`;

const Description = styled.p`
  margin-bottom: 1.1rem;
  font-weight: 700;
  font-size: 1.3em;
  padding: 20px 0px 20px 0px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

const Button = styled.button`
  font-weight: 500;
  padding: 9px 12px;
  margin-right: 4px;
  color: ${(props) => props.theme.color.darkBlue};
  background-color: ${(props) => props.theme.color.softPurple};
  border-radius: 2px;
  outline: none;
  border: none;
  margin-top: 5px;
  cursor: pointer;
`;
